import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { Box } from '@change-corgi/design-system-legacy/layout';

import type { FieldType, LinkQuestion } from '../../../../../../shared/types';

import { useLinkQuestionField } from './hooks/useLinkQuestionField';

type Props = {
	parent: FieldType;
	question: LinkQuestion;
};

export const LinkQuestionField: React.FC<Props> = ({ parent, question }) => {
	const {
		data: { questionLabel, urlWithParams },
	} = useLinkQuestionField({ parent, question });

	return (
		<Box>
			<Link to={urlWithParams} data-testid="reportAbuse-link" data-qa="reportAbuse-link">
				{questionLabel}
			</Link>
		</Box>
	);
};
